import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionFeatureAccess, OEVersionTargetsAlphaBetaProds, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OESkinTargetType as OESkinTargetType_, OESkinStartSelectionContent} from './oe-skin-consts';

export const OESkinTargetType = OESkinTargetType_;

export const OESkinTargets = new OEVersionTargetsAlphaBetaProds(
    {
        [OESkinTargetType.anatomy]: [
            OETarget.humanSkinMacro,
            OETarget.humanSkinMicro
        ]
    },
    {
        [OESkinTargetType.anatomy]: OETarget.humanSkinMacro,
    },
    {
        [OESkinTargetType.anatomy]: OETarget.humanSkinMacro,
    }
);

export const OESkinFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            anatomyTargetSelection: !isLicensing,
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.anatomyTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OESkinTargets);

export const OESkinStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OESkinTargets,
    OESkinStartSelectionContent
);